import React from "react";

import './styles.css'

import CloseIcon from '@mui/icons-material/Close';
import {
  IconButton,
  Box,
  Typography,
  Button,
} from '@mui/material';


function DeleteSessaoUtente(props){

  return (props.trigger) ? (
    <Box className="popup">
        <Box className="popup-inner">
            <Typography align="center" sx={{paddingTop:2}} variant="subtitle1">Deseja apagar a sessão "{props.sessao.title}"?</Typography>
            
            <Box textAlign='center' m={0}>
                <Button variant='contained' color='error' size="small" onClick={() => props.setTrigger(false)}>Apagar</Button>
                <Button variant='contained' color='inherit' size = "small" onClick={() => props.setTrigger(false)}>Cancelar</Button>
            </Box>
                
            <IconButton className="close-btn" onClick={() => props.setTrigger(false)}>
                <CloseIcon/>
            </IconButton>
            {props.children}
        </Box>
    </Box>
     
  ) : "";
}
export default DeleteSessaoUtente
